import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AppUpdateService } from "../app-versions/app-update.service";
import { redesignPages } from "../navigation/paths.const";
import { logSentry } from "../utils/sentry.utils";

export const IsAppVersionSupportedGuard = async () => {
  const appUpdateService = inject(AppUpdateService);
  const router = inject(Router);

  try {
    const updateState = await appUpdateService.getUpdateState();
    if (updateState === "force") {
      await router.navigate([redesignPages.forceUpdate]);
      return false;
    }

    return true;
  } catch (error) {
    logSentry(error);
    return true;
  }
};
